import React from 'react';
import { formatDateTime } from '../utils/time';

const ChildHeader = ({ child, networkHealthScore, onRefresh }) => {
  if (!child) return null;
  return (
    <div className="child-header">
      <div>
        <h1>
          {child.firstName} {child.lastName}
        </h1>
        <p className="child-header__meta">
          Case ID <strong>{child.caseId}</strong> • DOB {formatDateTime(child.dob)}
        </p>
        {child.tags && child.tags.length > 0 && (
          <div className="child-header__tags">
            {child.tags.map((tag) => (
              <span className="chip" key={tag}>
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className="child-header__actions">
        <div className="child-header__score">
          <span>Network Health</span>
          <strong>{networkHealthScore}</strong>
        </div>
        <button type="button" className="primary" onClick={onRefresh}>
          Refresh Data
        </button>
      </div>
    </div>
  );
};

export default ChildHeader;
